import {
  CATEGORY,
  CLASSIFICATION,
  COMMON_THEMATIC,
  EXPERTISE,
  FINANCIAL_PUBLICATION,
  PUBLICATION,
  REGION,
  THEMATIC,
} from './filters';
import { LinkDocument } from './link';

export enum DocumentType {
  BAR_CHART = 'bar_chart',
  COLD_ARTICLE = 'cold_article',
  CONTACT = 'contact',
  INVESTORS = 'investors',
  INVESTORS_DASHBOARD = 'investors_dashboard',
  INVESTORS_MATRIX = 'investors_matrix',
  INVESTORS_MENU = 'investors_menu',
  INVESTORS_TAB_CONTENT = 'investors_tab_content',
  INVESTORS_TABLE = 'investors_table',
  FINANCIAL_DEBT = 'financial_debt',
  FINANCIAL_KEY_FIGURES = 'financial_key_figures',
  FINANCIAL_PRESS_RELEASE = 'financial_press_release',
  FINANCIAL_PUBLICATION = 'financial_publication',
  FINANCIAL_RATING = 'financial_rating',
  FOOTER = 'footer',
  FOCUS = 'focus',
  HEADER = 'header',
  HOME = 'home',
  HUB = 'hub',
  HUB_ACTUS = 'hub_actus',
  HUB_NEWSROOM = 'hub_newsroom',
  HOT_ARTICLE = 'hot_article',
  LA_POSTE_EN_4 = 'la_poste_en_4',
  MEDIA_POPIN = 'media_popin',
  MEDIA_PRESS = 'media_presse',
  NEWSROOM = 'newsroom',
  PIE_CHART = 'pie_chart',
  PRESS_RELEASE = 'press_release',
  PROFILE = 'profile',
  SEARCH = 'search_page',
  SLIDER_POPIN = 'slider_popin',
  RSE = 'rse',
  TIMELINE_POPIN = 'timeline_popin',
  VIDEO_POPIN = 'video_popin',
}

export enum TranslationType {
  TRANSLATION = 'translation',
}

export type CustomType = DocumentType | TranslationType;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomType = {
  ...DocumentType,
  ...TranslationType,
};

export const singleDocumentTypes = [
  DocumentType.FINANCIAL_DEBT,
  DocumentType.FINANCIAL_KEY_FIGURES,
  DocumentType.FINANCIAL_PRESS_RELEASE,
  DocumentType.FINANCIAL_PUBLICATION,
  DocumentType.FINANCIAL_RATING,
  DocumentType.FOOTER,
  DocumentType.HEADER,
  DocumentType.HUB_ACTUS,
  DocumentType.HUB_NEWSROOM,
  DocumentType.NEWSROOM,
  DocumentType.SEARCH,
];

type DeprecatedWarning = {
  field: string;
  oldValue: string | boolean | number;
};

export type Document = {
  id: string;
  uid: string;
  type: DocumentType;
  lang: string;
  alternateLanguages: LinkDocument[];
  createdAt: number;
  updatedAt: number;
  deprecated?: DeprecatedWarning[];
  disableRgpbBanner?: boolean;
};

export type Translation = {
  id: string;
  type: TranslationType;
  lang: string;
  body: Record<string, string>;
};

export type Filters = {
  category?: CATEGORY;
  classification?: CLASSIFICATION;
  commonThematic?: COMMON_THEMATIC;
  expertise?: EXPERTISE;
  financialPublication?: FINANCIAL_PUBLICATION;
  mediaThematic?: THEMATIC;
  mediaType?: string;
  publication?: PUBLICATION;
  region?: REGION;
  thematic?: THEMATIC;
};
